import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center pdb-20" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Locals")
], -1)
const _hoisted_3 = { class: "bordered-card bordered-card_secondary" }
const _hoisted_4 = { class: "filters d-flex gap-4 flex-column flex-md-row justify-content-between w-100" }
const _hoisted_5 = { class: "d-flex gap-4 col-md-8 col-sm-12 flex-column flex-md-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_LocalsRequests = _resolveComponent("LocalsRequests")!
  const _component_SearchLocalsList = _resolveComponent("SearchLocalsList")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      errors: $setup.errors,
      success: $setup.success
    }, null, 8, ["errors", "success"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.filters.Type,
              "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.Type) = $event)),
              options: $setup.types,
              "single-arrow": true,
              customClass: "fs-xs"
            }, null, 8, ["selectedOption", "options"]),
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.filters.Local,
              "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.Local) = $event)),
              options: $setup.localsFilterOptions,
              "single-arrow": true,
              customClass: "fs-xs",
              defaultOption: { key: 0, value: 'Filter by Local #' }
            }, null, 8, ["selectedOption", "options"])
          ]),
          _createVNode(_component_TextInput, {
            type: "text",
            name: "mixed",
            placeholder: "Search by Local, Name",
            max: 50,
            modelValue: $setup.filters.OrgName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.OrgName) = $event)),
            customClass: "search col-3 col-sm-6"
          }, null, 8, ["modelValue"])
        ]),
        ($setup.loading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
          : ($setup.filters.Type.key == 0)
            ? (_openBlock(), _createBlock(_component_LocalsRequests, {
                key: 1,
                locals: $setup.pendingLocals,
                onSendPin: $setup.sendPin,
                onRejectRequest: $setup.rejectRequest
              }, null, 8, ["locals", "onSendPin", "onRejectRequest"]))
            : (_openBlock(), _createBlock(_component_SearchLocalsList, {
                key: 2,
                locals: $setup.locals,
                onResetPin: $setup.resetPin,
                onActivate: $setup.activateAccount,
                onDeactivate: $setup.deactivateAccount,
                onChangeRole: $setup.changeRole
              }, null, 8, ["locals", "onResetPin", "onActivate", "onDeactivate", "onChangeRole"]))
      ]),
      (!$setup.loading)
        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
            key: 0,
            paginator: $setup.paginator,
            onFetchData: $setup.fetchPaginationData
          }, null, 8, ["paginator", "onFetchData"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}